import React from "react"
import {
  FormInputContainer,
  FormInputWrapper,
  Input,
  Label,
  UnitText,
  UnitWrapper,
  NumericFormatInput,
  HelpText,
  TextArea,
  ValidationText
} from "../../styles"
import PropTypes from "prop-types"
import { isNullOrUndefined } from "../../../utils/utils"

function FormInput({ onChange, label, id, unit, value, type, helpText, validationText, ...otherProps }) {
  const handleOnChange = (e, values) => {
    let value = !isNullOrUndefined(values) ? values.value : e.target.value
    if (type === "number") {
      if (!isNullOrUndefined(value) && value !== "") value = Number(value)
    }
    onChange(value, id)
  }
  return (
    <FormInputWrapper>
      {label && <Label htmlFor={id}>{label}</Label>}
      <FormInputContainer>
        {type === "number" ? (
          <NumericFormatInput
            onValueChange={(values, sourceInfo) => {
              handleOnChange(sourceInfo, values)
            }}
            value={value}
            valueIsNumericString={true}
            id={id}
            aria-describedby={unit ? `${id}-unit` : null}
            thousandSeparator=","
            {...otherProps}
          />
        ) : type === "textArea" ? (
          <TextArea
            type={type}
            onChange={handleOnChange}
            value={value}
            id={id}
            rows={5}
            {...otherProps}
          />
        ) : 
        (
          <Input
            type={type}
            onChange={handleOnChange}
            value={value}
            id={id}
            aria-describedby={unit ? `${id}-unit` : null}
            {...otherProps}
          />
        )}

        {unit && (
          <UnitWrapper>
            <UnitText id={`${id}-unit`}>{unit}</UnitText>
          </UnitWrapper>
        )}        
      </FormInputContainer>
      {validationText && <ValidationText htmlFor={id}>{validationText}</ValidationText>}
      {helpText && <HelpText htmlFor={id}>{helpText}</HelpText>}


    </FormInputWrapper>
  )
}

/** Accepts the below, as well as any of the usual input props */
FormInput.propTypes = {
  /** Called on change of value, with new value and id */
  onChange: PropTypes.func,
  /** The label for the input */
  label: PropTypes.string,
  /** A unique id for the input, e.g a field name */
  id: PropTypes.string,
  /** Unit name, if required */
  unit: PropTypes.string,
  /** The value of the input */
  value: PropTypes.any,
  /** helptext below input */
  helpText: PropTypes.string,
  /** validation below input */
  validationText: PropTypes.string,


}

export default FormInput
